import { render } from "./MailRequestEmployeeExit.vue?vue&type=template&id=494f9df3&scoped=true"
import script from "./MailRequestEmployeeExit.vue?vue&type=script&lang=js"
export * from "./MailRequestEmployeeExit.vue?vue&type=script&lang=js"

import "./MailRequestEmployeeExit.vue?vue&type=style&index=0&id=494f9df3&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494f9df3"]])

export default __exports__